import { seoContent } from "@/mocks/home";
import { Link } from "react-router-dom";

export default function SEOContent() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 lg:px-14 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[45%]">
            <span className="inline-block text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
              Guia SEO
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-5">
              {seoContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
              {seoContent.summary}
            </p>
            <Link
              to={seoContent.linkUrl}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              {seoContent.linkText}
            </Link>
          </div>

          <div className="w-full lg:w-[55%] flex gap-4">
            <div className="w-[40%]">
              <div className="rounded-3xl overflow-hidden h-72 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20closeup%20detail%20of%20a%20quality%20inspection%20checklist%20on%20a%20clipboard%20next%20to%20a%20pair%20of%20sneakers%20on%20a%20warm%20walnut%20table%2C%20a%20magnifying%20glass%20and%20measuring%20tape%20beside%20them%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20professional%20product%20quality%20control%20photography%20with%20rich%20wood%20tones&width=500&height=640&seq=seo-qc-v02&orientation=portrait"
                  alt="QC real CSSBuy Spreadsheet"
                  title="Controle de Qualidade CSSBuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="w-[60%]">
              <div className="rounded-3xl overflow-hidden h-72 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20warehouse%20interior%20with%20organized%20shelving%20units%20filled%20with%20packaged%20fashion%20products%2C%20warm%20overhead%20lighting%20casting%20soft%20patterns%2C%20a%20worker%20in%20the%20distance%20checking%20inventory%2C%20professional%20logistics%20photography%20with%20clean%20industrial%20aesthetic&width=700&height=640&seq=seo-warehouse-v02&orientation=landscape"
                  alt="Armazém CSSBuy Spreadsheet"
                  title="Centro de Distribuição CSSBuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}